import { OrderStatus } from "@/types";

export const shippingStatuses = {
    Approved: "Approved",
    InTransit: "In Transit",
    OutForDelivery: "Out For Delivery",
    Delivered: "Delivered",
    DeliveryFailed: "Delivery Failed",
};

export function getStatusColors(status: string) {
    
    if (status === OrderStatus.Requested) {
        return "warning";
    }
    if (status === OrderStatus.Processing) {
        return "secondary";
    }
    if (status === OrderStatus.Purchased) {
        return "danger";
    }
    if (status === OrderStatus.InTransit) {
        return "success";
    }
    if (status === OrderStatus.Delivered) {
        return "info";
    }
    if (status === OrderStatus.Cancelled) {
        return "danger";
    }
    return "success";
}
